import { frontendURL } from 'dashboard/helper/URLHelper.js';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import SocialRouteView from './pages/SocialRouteView.vue';

const SocialDashboard = () => import('./pages/SocialDashboard.vue');
const SocialComments = () => import('./pages/SocialComments.vue');
const SocialSettings = () => import('./pages/SocialSettings.vue');
const SocialAutomations = () => import('./pages/SocialAutomations.vue');

const viewMeta = {
  featureFlag: FEATURE_FLAGS.SOCIAL,
  permissions: ['administrator', 'agent', 'social_view'],
};

const configureMeta = {
  featureFlag: FEATURE_FLAGS.SOCIAL,
  permissions: ['administrator', 'social_configure'],
};

const socialRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/social'),
      component: SocialRouteView,
      children: [
        {
          path: '',
          name: 'social_dashboard',
          meta: viewMeta,
          component: SocialDashboard,
        },
        {
          path: ':inboxId/comments',
          name: 'social_comments',
          meta: viewMeta,
          component: SocialComments,
          props: true,
        },
        {
          path: ':inboxId/automations',
          name: 'social_automations',
          meta: configureMeta,
          component: SocialAutomations,
          props: true,
        },
        {
          path: ':inboxId/settings',
          name: 'social_settings',
          meta: configureMeta,
          component: SocialSettings,
          props: true,
        },
      ],
    },
  ],
};

export default socialRoutes;
